import React from 'react';
import { useSelector } from 'react-redux';
var PermissionGuard = function (_a) {
    var children = _a.children, requiredPermission = _a.requiredPermission, _b = _a.requiredAccess, requiredAccess = _b === void 0 ? 'View' : _b;
    var userBasicInfo = useSelector(function (store) { return store.User.userData; });
    var rolePermissions = (userBasicInfo === null || userBasicInfo === void 0 ? void 0 : userBasicInfo.RolePermissions) || [];
    var roleType = userBasicInfo === null || userBasicInfo === void 0 ? void 0 : userBasicInfo.RoleType;
    var isViewActionEnabled = function (perm) {
        return Number(perm.View) === 1;
    };
    var hasAccess = function () {
        var permissionObj = rolePermissions.find(function (perm) { return perm.PermissionKey === requiredPermission; });
        if (permissionObj) {
            if (requiredAccess === 'View') {
                if (isViewActionEnabled(permissionObj))
                    return true;
            }
            else {
                if (Number(permissionObj[requiredAccess]) === 1)
                    return true;
            }
        }
        var hasEnabledChild = rolePermissions.some(function (perm) {
            return perm.PermissionKey.startsWith("".concat(requiredPermission, ":")) &&
                (requiredAccess === 'View'
                    ? isViewActionEnabled(perm)
                    : Number(perm[requiredAccess]) === 1);
        });
        if (hasEnabledChild)
            return true;
        return false;
    };
    if (!hasAccess()) {
        return null;
    }
    return React.createElement(React.Fragment, null, children);
};
export default PermissionGuard;
